import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Alert,
  CircularProgress,
  Stack,
  Divider
} from '@mui/material';

export default function RefreshConfirmDialog({ open, onClose, onConfirm, remainingQuota, usedToday, isLoading }) {
  const getColor = () => {
    if (remainingQuota > 5) return 'success.main';
    if (remainingQuota > 2) return 'warning.main';
    return 'error.main';
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle id="alert-dialog-title">Refresh Power BI Dataset</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Update your Power BI report with the latest data. This action will consume your daily refresh quota.
        </Typography>

        <Stack direction="row" spacing={2} mb={3} divider={<Divider orientation="vertical" flexItem />}>
          <Box flex={1} textAlign="center">
            <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
              REMAINING
            </Typography>
            <Typography variant="h4" fontWeight="bold" sx={{ color: getColor() }}>
              {remainingQuota}
            </Typography>
          </Box>
          <Box flex={1} textAlign="center">
            <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
              USED TODAY
            </Typography>
            <Typography variant="h4" fontWeight="bold">
              {usedToday}
            </Typography>
          </Box>
        </Stack>

        {remainingQuota <= 0 && (
          <Alert severity="error" sx={{ mb: 1, borderRadius: 2 }}>
            Refresh quota exhausted for today.
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={isLoading}>
          CANCEL
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={remainingQuota <= 0 || isLoading}
          startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isLoading ? 'REFRESHING...' : 'REFRESH'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
